// import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { uniqueId } from 'lodash';
import api from '../../api';

import { Meeting } from './types';

export async function getMeetingsRequest() {
  try {
    const response = await api().get('/meetings');

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getFutureMeetingsRequest(
  userId: string,
  companyId: string,
  search: string,
  page: string,
) {
  try {
    const response = await api().get(`/meetings/future/${userId}`, {
      headers: {
        companyId,
      },
      params: {
        search,
        page,
        size: '100',
      },
    });

    return response?.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getPastMeetingsRequest(
  userId: string,
  companyId: string,
  search: string,
) {
  try {
    const response = await api().get(`/meetings/past/${userId}`, {
      headers: {
        companyId,
      },
      params: {
        search,
        page: '1',
        size: '100',
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getFutureMeetingByBoardIdRequest(
  boardId: string,
  userId: string,
) {
  try {
    const response = await api().get(`/meetings/future/board/${boardId}`, {
      headers: {
        userId,
      },
      params: {
        search: '',
        page: '1',
        size: '100',
      },
    });

    return response;
  } catch (err) {
    console.log(err);
    return null;
  }
}

export async function getPastMeetingByBoardIdRequest(
  boardId: string,
  userId: string,
) {
  try {
    const response = await api().get(`/meetings/past/board/${boardId}`, {
      headers: {
        userId,
      },
      params: {
        search: '',
        page: '1',
        size: '100',
      },
    });

    return response;
  } catch (err) {
    console.log(err);
    return null;
  }
}

export async function getCanceledMeetingsByUse(
  userId: string,
  companyId: string,
  search: string,
) {
  try {
    const response = await api().get(`/meetings/canceled/${userId}`, {
      headers: {
        companyId,
      },
      params: {
        search: '',
        page: '1',
        size: '100',
      },
    });

    return response;
  } catch (err) {
    console.log(err);
    return null;
  }
}

export async function createMeetingRequest(
  meeting: Partial<Meeting>,
  userId: string,
  boardId: string,
  companyId: string,
  hasTeamsMeeting: boolean,
  hasJitsiMeeting: boolean,
  zoomCode?: any,
  redirectUrlZoom?: any,
) {
  try {
    const guests = meeting.guests!.length;

    const data = {
      ...meeting,
      status: 'MS1',
      guests: guests > 0 ? meeting.guests : [],
      user_id: userId,
      board_id: boardId,
      company_id: companyId,
      video_conference_id: null,
      file_id: null,
      ata_url: null,
    };

    const response = await api().post('/meetings', data, {
      headers: {
        companyId,
        userId,
        hasTeamsMeeting,
        hasJitsiMeeting,
        zoomCode,
        redirectUrlZoom,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function updateMeetingRequest(
  meeting: Partial<Meeting>,
  meetingId: string,
  userId: string,
  companyId: string,
  hasJitsiMeeting?: any,
  zoomCode?: any,
  redirectUrlZoom?: any,
) {
  try {
    const data = {
      ...meeting,
      user_id: userId,
    };
    const response = await api().patch(`/meetings/${meetingId}`, data, {
      headers: {
        companyId,
        userId,
        hasJitsiMeeting,
        zoomCode,
        redirectUrlZoom,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}

export async function cancelMeetingRequest(
  meetingId: string,
  userId: string,
  companyId: string,
) {
  try {
    const response = await api().patch(
      `/meetings/remove/${meetingId}`,
      {},
      {
        headers: {
          companyId,
          userId,
        },
      },
    );

    if (response?.status === 200) {
      toast.success('Reunião cancelada com sucesso');
      return response;
    }

    return null;
  } catch (error: any) {
    console.log('cancelMeetingRequest error', error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    return null;
  }
}

export async function activeMeetingRequest(
  meetingId: string,
  companyId: string,
  userId: string,
) {
  try {
    const response = await api().patch(
      `/meetings/active/${meetingId}`,
      {},
      {
        headers: {
          companyId,
          userId,
        },
      },
    );
    if (response?.status === 200) {
      toast.success('Reunião reativada com sucesso');
      return response;
    }
    return null;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error('activeMeetingRequest => ', error);
    return null;
  }
}

export async function getMeetingByIdRequest(meetingId: string, userId: string) {
  try {
    const response = await api().get(`/meetings/${meetingId}`, {
      headers: {
        userId,
      },
    });

    return response.data;
  } catch (error) {
    console.error('getMeetingByIdRequest => ', error);
    return null;
  }
}

export async function sendNotificationThemesRequest(meetingId: string) {
  try {
    const response = await api().post(
      `/meetings/notification-theme/${meetingId}`,
    );

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error('sendNotificationThemesRequest => ', error);
    return null;
  }
}

export async function getEbookByMeetingIdRequest(
  meetingId: string,
  userId: string,
  isDownloaded = 'false',
) {
  try {
    const response = await api().get(`/meetings/ebook/${meetingId}`, {
      headers: {
        userId,
        isDownloaded,
      },
    });

    const responseBlob = await fetch(
      `data:application/octet-binary;base64,${response?.data}`,
    ).then(res => res.blob().then(b => URL.createObjectURL(b)));

    return {
      data: responseBlob,
      status: response.status,
    };
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte');
    } else if (error.response.status === 401) {
      console.error('Não autorizado');
      return null;
    } else {
      toast.error(error.response.data.message);
    }

    console.error('getEbookByMeetingIdRequest => ', error);
    return null;
  }
}

export async function sendMeetingInviteRequest(
  meetingId: string,
  userId: string,
) {
  try {
    const response = await api().post(
      `/meetings/invite/${meetingId}`,
      {},
      {
        headers: {
          userId,
        },
      },
    );

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error('createMeetingInviteRequest', error);
    return null;
  }
}
